export function pluralize(n: number, forms: string[]): string {
    let plural = (n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    return forms[plural];
}